import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FactorManager from './FactorManager';

export default function Factors() {
  return (
    <Grid item xs={12}>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column'
        }}>
        <FactorManager />
      </Paper>
    </Grid>
  );
}
